const Colors = {
  primary: "#040721",
  secondary: "#f9da87",
};

export default Colors;
